import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '../../../lib/network/http-client';
import { ClientState } from './client-state';

@Injectable()
export class ClientStateService {
  constructor(private httpClient: HttpClient) {}

  loadState(): Observable<ClientState> {
    return this.httpClient
      .get('/client-state')
      .pipe(map((response) => plainToClass(ClientState, response)));
  }

  saveState(state: ClientState): Observable<ClientState> {
    return this.httpClient.post('/client-state', state);
  }
}
